var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackarrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 91,
    viewBox: "0 0 99 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_53_1490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.5625 37.0018C65.916 37.0018 37.6537 37.0018 37.6537 37.0018L46.5019 26.1028C46.9156 25.5923 47.1147 24.9341 47.0552 24.2731C46.9958 23.6121 46.6828 23.0024 46.185 22.5781C45.6872 22.1538 45.0455 21.9496 44.4009 22.0106C43.7564 22.0715 43.1619 22.3926 42.7481 22.9031L30.5606 37.9017C30.4786 38.021 30.4053 38.1463 30.3412 38.2767C30.3412 38.4017 30.3413 38.4767 30.1706 38.6016C30.0601 38.8883 30.0023 39.1934 30 39.5016C30.0023 39.8098 30.0601 40.1149 30.1706 40.4015C30.1706 40.5265 30.1706 40.6015 30.3412 40.7265C30.4053 40.8568 30.4786 40.9821 30.5606 41.1014L42.7481 56.1001C42.9773 56.3823 43.2643 56.6092 43.5887 56.7647C43.9131 56.9203 44.2669 57.0006 44.625 57C45.1945 57.0011 45.7465 56.7977 46.185 56.425C46.4318 56.2152 46.6358 55.9575 46.7854 55.6666C46.9349 55.3758 47.0271 55.0575 47.0565 54.7301C47.0859 54.4027 47.0521 54.0726 46.9569 53.7586C46.8618 53.4446 46.7071 53.153 46.5019 52.9004L37.6537 42.0013H66.5625C67.209 42.0013 67.829 41.738 68.2861 41.2692C68.7432 40.8004 69 40.1645 69 39.5016C69 38.8386 68.7432 38.2028 68.2861 37.734C67.829 37.2652 67.209 37.0018 66.5625 37.0018Z",
    fill: "#3B4F7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_53_1490",
    x: 0,
    y: -4,
    width: 99,
    height: 95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_53_1490"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_53_1490",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackarrow);
export default __webpack_public_path__ + "static/media/blackarrow.726a7e1942a6b66501904bedf537f01c.svg";
export { ForwardRef as ReactComponent };